<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search()}}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="search1" (click)='filter()'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <button class="search1 hidden-xs" (click)='load_data4(1)' [ngClass]="{active1:invoice_type == 1}">
                    <span>خرید ها</span>
                </button>
                <button class="search1 hidden-xs" (click)='load_data4(3)' [ngClass]="{active1:invoice_type == 3}">
                    <span>فروش ها</span>
                </button>
                <button (click)='load_data2()' class="hidden-xs"
                    [ngClass]="{active1:negative == true && invoice_type == 0}" *ngIf="level == 1">-</button>
                <button (click)='load_data3()' [ngClass]="{active1:negative == false && invoice_type == 0}">
                    {{ messageService.get_all()}}
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll_bg pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'
                (click)="reset_sort('wharehouse_order_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:40px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="max-width:90px" [ngClass]="{active1:order == 'date ' + asc_desc }"
                (click)="sort('date',asc_desc)">
                <span>تاریخ</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px;direction: rtl;"
                (click)="order_ref(i,x.ref)">
                <div>{{x.date}}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:90px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="material_title">
            <mat-header-cell *matHeaderCellDef style="min-width:400px"
                [ngClass]="{active1:order == 'wharehouse_material_title ' + asc_desc }"
                (click)="sort('wharehouse_material_title',asc_desc)">
                <span>نام کالا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width:400px" (click)="order_ref(i,x.ref)">
                <div class="right"> {{ x.wharehouse_material_cate_title
                    | substr:0:15 }} | {{x.wharehouse_material_title | substr:0:50 }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width:400px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'user_title ' + asc_desc }"
                (click)="sort('user_title',asc_desc)" style="min-width:200px">
                <span>عنوان طرف حساب</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)" style="min-width:200px">
                <div class="right">{{x.user_title || '-' }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width:200px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="type_title">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'type_title ' + asc_desc }"
                (click)="sort('type_title',asc_desc)">
                <span>نوع گردش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)">
                <div class="right">{{x.type_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="imported">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'imported ' + asc_desc }"
                (click)="sort('imported',asc_desc)">
                <span>ورود به انبار</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)">
                {{x.imported || '-' }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="exited">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'exited ' + asc_desc }"
                (click)="sort('exited',asc_desc)">
                <span>خروج از انبار </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)">
                {{x.exited || '-' }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="remain">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'inventory ' + asc_desc }"
                (click)="sort('inventory',asc_desc)">
                <span>مانده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [ngClass]="{red:x.inventory < 0 }" (click)="check(i,x.ref)">
                <div class="amount" *ngIf="x.inventory_loading == false"> {{ x.inventory || '0' }}</div>
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="x.inventory_loading == true">
                    <span class="sr-only">Loading...</span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'price ' + asc_desc }"
                (click)="sort('price',asc_desc)">
                <span>قیمت واحد</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)">
                {{ x.price | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="sum">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'sum ' + asc_desc }"
                (click)="sort('sum',asc_desc)">
                <span>جمع کل</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="order_ref(i,x.ref)">
                {{ x.sum | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_all |
                number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="searial">
            <mat-header-cell *matHeaderCellDef style="max-width:90px">
                <span>سریالها</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px;direction: rtl;">
                <span
                    (click)="open_serial(i,x.wharehouse_order_id,x.wharehouse_material_title,x.wharehouse_order_consumed_invoice,x.invoice_type)">
                    <i class="fas fa-info-circle icon"></i>
                </span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:90px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="material_id">
            <mat-header-cell *matHeaderCellDef style="max-width:90px"
                [ngClass]="{active1:order == 'wharehouse_material_id ' + asc_desc }"
                (click)="sort('wharehouse_material_id',asc_desc)">
                <span>شناسه کالا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:90px;direction: rtl;"
                (click)="order_ref(i,x.ref)">
                {{x.wharehouse_material_id }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:90px"></mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true">
        </mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview2.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>